import React from 'react';
import { Link } from 'react-router-dom';
import { useCategory } from '../context/CategoryContext';
import './CategoryShortcut.css';

const services = [
  { label: 'Gypsum Ceilings',        sub: 'Design & install',   to: '/gypsum-ceiling',            icon: 'ti-layout-grid' },
  { label: 'Materials & Hardware',    sub: 'Supply & sourcing',  to: '/shop',                      icon: 'ti-tools' },
  { label: 'Kitchen Cabinets',        sub: 'Custom fitted',      to: '/kitchen-wardrobe-fitting',  icon: 'ti-tools-kitchen-2' },
  { label: 'Wardrobes',               sub: 'Built-in & sliding', to: '/kitchen-wardrobe-fitting',  icon: 'ti-door' },
  { label: 'TV Wall Units',           sub: 'Feature walls',      to: '/tv-gypsum-wall',            icon: 'ti-device-tv' },
  { label: 'Wainscoting Panels',      sub: 'Wall finishing',     to: '/wain-scouting',             icon: 'ti-layout-board' },
];

const CategoryShortcut = () => {
  const { categories, loading, error } = useCategory();

  const parentCategories = categories.filter(
    cat => cat.parent_id === 0 && cat.status === 1
  );

  return (
    <section className="cs-section">
      <div className="cs-content">

        {/* ── Hero ── */}
        <div className="cs-hero">
        {/* <div className="cs-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
            Techie Interiors
          </div> */}


          <h1 className="cs-headline">
            <span className="cs-headline-brand">Techie Interiors</span>
            <span className="cs-headline-line">
              <Link to="/gypsum-ceiling" className="cs-headline-link">
                Gypsum Ceilings
              </Link>
              <span className="cs-headline-sep">, </span>
              <Link to="/kitchen-wardrobe-fitting" className="cs-headline-link">
                Kitchens &amp; Wardrobes
              </Link>
              <span className="cs-headline-sep">, and </span>
              <Link to="/wain-scouting" className="cs-headline-link">
                wall panels
              </Link>
              <span className="cs-headline-tagline"> — Interior Finishes in Nairobi</span>
            </span>
          </h1>

          <p className="cs-subtext">
            We design, install, and{' '}
            <Link to="/shop" className="cs-inline-link">supply</Link>{' '}
            modern interior solutions — from gypsum ceilings and kitchens to
            wardrobes, wall panels, and quality hardware materials.
          </p>

          <div className="cs-cta-row">
            <a
              className="cs-btn cs-btn--primary"
              href="https://wa.me/254748600208?text=Hi%20Techie%20Interiors,%20I%20need%20a%20quote."
              target="_blank"
              rel="noreferrer"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.555 4.116 1.523 5.845L.057 23.943l6.266-1.444A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.659-.52-5.17-1.424l-.371-.22-3.819.88.926-3.698-.242-.383A9.937 9.937 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
              Get Quote on WhatsApp
            </a>
            <a className="cs-btn cs-btn--secondary" href="tel:+254748600208">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.07 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z"/></svg>
              Call Now
            </a>
          </div>
        </div>

        {/* ── Divider ── */}
        <div className="cs-divider" />

        {/* ── What We Do ── */}
        <div className="cs-whatwedo">
          <div className="cs-section-label">What we do</div>

          <p className="cs-whatwedo-intro">
            Complete interior finishing solutions — from design and installation
            to supply of materials.
          </p>

          <div className="cs-services-grid" role="list">
            {services.map(({ label, sub, to, icon }) => (
              <Link className="cs-service-card" to={to} role="listitem" key={label}>
                <div className="cs-service-icon" aria-hidden="true">
                  <i className={`ti ${icon}`} />
                </div>
                <div className="cs-service-text">
                  <span className="cs-service-name">{label}</span>
                  <span className="cs-service-sub">{sub}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* ── Category image grid ── */}
        {loading && <div className="cs-status">Loading categories…</div>}
        {error   && <div className="cs-status cs-status--error">Error: {error}</div>}

        {!loading && !error && (
          <div className="category-grid">
            {parentCategories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="category-card"
              >
                <img
                  src={category.image_fullpath || category.image}
                  alt={category.name}
                  className="category-image"
                />
                <div className="category-overlay">
                  <div className="category-info">
                    <h4 className="category-card-title">{category.name}</h4>
                    <span className="category-arrow">→</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CategoryShortcut;